<template>
  <div id="AssuranceSupport">
    <div class="support">
      <main>
        <img src="../assets/Conversion/construction.png">
      </main>
    </div>
  </div>
</template>
<script>
export default {
  name: "AssuranceSupport",
  data() {
    return {
      
    };
  }
};
</script>
<style lang="less" scoped>
.support {
  main{
    width: 100%;
    height: 7rem;
    position: relative;
    img{
      width: 4.67rem;
      height: 3.9rem;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
    }
  }
}
</style>